import { render, staticRenderFns } from "./HealthError.vue?vue&type=template&id=85cfcfc0&"
import script from "./HealthError.vue?vue&type=script&lang=ts&"
export * from "./HealthError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports